var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndexComparisonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 32,
    viewBox: "0 0 12 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0L6 32",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeDasharray: "3 2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22727 14.5455H4.31818L2.8125 18.892H2.75568L1.25 14.5455H0.340909L2.35795 20H3.21023L5.22727 14.5455ZM10.1971 15.767C9.9343 14.9929 9.34482 14.4744 8.26527 14.4744C7.1147 14.4744 6.26243 15.1278 6.26243 16.0511C6.26243 16.804 6.70987 17.3082 7.71129 17.5426L8.62038 17.7557C9.17081 17.8835 9.43004 18.1463 9.43004 18.5227C9.43004 18.9915 8.93288 19.375 8.15163 19.375C7.46626 19.375 7.03658 19.0803 6.88743 18.4943L6.09197 18.6932C6.28729 19.62 7.05078 20.1136 8.16584 20.1136C9.43359 20.1136 10.2965 19.4212 10.2965 18.4801C10.2965 17.7202 9.82067 17.2408 8.84766 17.0028L8.038 16.804C7.39169 16.6442 7.1005 16.4276 7.1005 16.0085C7.1005 15.5398 7.59766 15.1989 8.26527 15.1989C8.9968 15.1989 9.29865 15.6037 9.44425 15.9801L10.1971 15.767Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexComparisonIcon);
export default __webpack_public_path__ + "static/media/index_comparison_icon.b8661f405bef298cb0b7ff33daf4baa3.svg";
export { ForwardRef as ReactComponent };